import { Color, lch, rgb } from "./customColor";

export const getColorWeight = (color: Color): number => {

    const {c} = lch(color);
    const perceivedLightness = getColorPerceivedLightness(color);

    const chromaWeight = Math.pow(Math.max(c / 100, 0), 2.2);
    const lightnessWeight = Math.pow(1 - Math.abs(perceivedLightness - 60) / 60, 2);
    const greynessWeight = getGreynessWeight(color);

    const weight = (0.7 * chromaWeight + 0.2 * lightnessWeight + 0.1 * greynessWeight) * 100;

    return Math.min(Math.max(weight, 0), 100);
};

const getGreynessWeight = (color: Color): number => {

    const {l, c} = lch(color);
    const isInGreyZone = (c < 15 || l < 10 || (c < 25 && l > 30 && l < 70));

    if (isInGreyZone) {

        if (l < 10) {
            return 0.05;
        }

        return Math.max(0.1, (c / 30));
    } else {
        return Math.min(1, 0.7 + (c / 100));
    }
};

// https://stackoverflow.com/a/56678483
// <br>
// Returns a number between 0 (black) and 100 (white) where 50 is the perceptual "middle grey".
const getColorPerceivedLightness = (color: Color): number => {

    const {r, g, b} = rgb(color);

    // converts gamma-encoded RGB channel to a linear value.
    const toLinear = (c: number): number => {
        if (c <=  0.04045) {
            return c / 12.92;
        } else {
            return Math.pow(((c + 0.055) / 1.055), 2.4);
        }
    };

    // Luminance
    const Y = (0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b));

    if (Y <= 216 / 24389) {
        return Y * (24389 / 27);
    } else {
        return Math.pow(Y, 1 / 3) * 116 - 16;
    }
};